module.exports = __webpack_public_path__ + "static/ss2.4669ee02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/rc/ss2.jpg
// module id = 1174
// module chunks = 277036769636407